class CoreDrawer extends HTMLElement {
  connectedCallback() {
    this.querySelectorAll('[data-close]').forEach(el => el.addEventListener('click', () => this.close()));
    document.addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
  }
  open() { this.hidden = false; requestAnimationFrame(() => this.classList.add('is-open')); document.body.classList.add('drawer-open'); }
  close() { this.classList.remove('is-open'); document.body.classList.remove('drawer-open'); setTimeout(() => { this.hidden = true; }, 250); }
}
customElements.define('core-drawer', CoreDrawer);

document.addEventListener('click', e => {
  const trigger = e.target.closest('[data-drawer]');
  if (trigger) document.querySelector(trigger.dataset.drawer)?.open();

  const footerTrigger = e.target.closest('[data-footer-page]');
  if (footerTrigger) {
    e.preventDefault();
    document.getElementById(footerTrigger.dataset.footerPage)?.classList.add('is-open');
    document.body.classList.add('drawer-open');
  }

  const footerClose = e.target.closest('.footer-info-page__close');
  if (footerClose) {
    e.preventDefault();
    footerClose.closest('.footer-info-page')?.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const paymentItem = document.querySelector('.commerce-item:first-child');
  if (paymentItem) {
    const paymentTitle = paymentItem.querySelector('h3');
    const paymentText = paymentItem.querySelector('p');
    const paymentLink = paymentItem.querySelector('[data-footer-page="formas-de-pago"]');
    if (paymentTitle) paymentTitle.textContent = 'ELIGE CÓMO PAGAR';
    if (paymentText) paymentText.textContent = 'Paga con tarjeta, transferencia SPEI u otros métodos disponibles al finalizar tu compra.';
    if (paymentLink) paymentLink.textContent = 'Ver formas de pago →';
  }
  const observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); }
  }), { threshold: .12 });
  document.querySelectorAll('[data-reveal]').forEach(el => observer.observe(el));
});

document.addEventListener('change', async e => {
  if (!e.target.matches('[data-variant-select]')) return;
  const option = e.target.selectedOptions[0];
  const form = e.target.closest('form');
  form.querySelector('[name="id"]').value = option.value;
  const price = form.closest('[data-product]')?.querySelector('[data-price]');
  if (price && option.dataset.price) price.textContent = option.dataset.price;
});

document.addEventListener('keydown', e => {
  if (e.key !== 'Escape') return;
  document.querySelectorAll('.footer-info-page.is-open').forEach(page => page.classList.remove('is-open'));
  document.body.classList.remove('drawer-open');
});
